// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  appName: 'Aether Software Platform',
  firebase: {
    //Firebase config
    apiKey: 'AIzaSyBUNtLqIdTNBNYhbLkNDMhJDj9o9bS7I38',
    authDomain: 'asp-2021.firebaseapp.com',
    projectId: 'asp-2021',
    storageBucket: 'asp-2021.appspot.com',
    messagingSenderId: '322585890327',
    appId: '1:322585890327:web:7853807e84dd17e643d652',
    measurementId: 'G-TRNJ3KR9B2',
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
